var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Facebook Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2058_7754",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.291687H14.2818V30H0V0.291687Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2058_7754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.482 16.9275L14.1128 11.4904H9.27074V8.01835C9.27074 6.4441 9.6665 5.37099 11.6948 5.37099L14.2818 5.36959V0.505839C13.8358 0.44003 12.3001 0.291687 10.511 0.291687C6.77741 0.291687 4.22281 2.82571 4.22281 7.48031V11.4904H0V16.9275H4.22281V30H9.27074V16.9275H13.482Z",
    fill: "#FFDD00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookYellow);
export default __webpack_public_path__ + "static/media/facebook-yellow.deacf6f3f0eff7fbab8f330809483a9c.svg";
export { ForwardRef as ReactComponent };